import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-3"
};
const _hoisted_2 = {
    key: 1,
    class: "mt-3"
};
const _hoisted_3 = { class: "-mx-6 border-t-2 mt-8" };
const _hoisted_4 = { class: "pt-6 px-6 flex justify-between items-center" };
const _hoisted_5 = ["href"];
const _hoisted_6 = { class: "flex items-center gap-3" };
import { useVerification } from '@/composition/useVerification';
import { getHelpVideoLink } from '@/utility';
import { PlaySquareIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIAlert, UIButton, UITextLgMedium, UITextSmMedium, } from '@gohighlevel/ghl-ui';
import { inject, onMounted, onUnmounted } from 'vue';
import DomainConnectRecordTable from './DomainConnectRecordTable.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DomainConnectOtherProviders',
    props: {
        configuration: null,
        domain: null,
        template: null,
        subDomainValue: null,
        recordTableData: null
    },
    emits: ["closeModal", "resetState"],
    setup(__props, { emit }) {
        const props = __props;
        const emitter = inject('emitter');
        const { isErrorVerifyingDomain, isLoading, onAuthorized, onReceivedConfirmation, } = useVerification();
        const verifyDomain = () => {
            onAuthorized({
                domain: props.domain,
                addRootOrWWW: props.configuration.addRootOrWWW,
                subdomain: props.subDomainValue,
                template: props.template,
            });
        };
        onMounted(() => {
            emitter.on('onReceiveDomainConnectConfirmation', (payload) => {
                onReceivedConfirmation(payload);
                if (payload.flag) {
                    emitter.off('onReceiveDomainConnectConfirmation');
                    emit('closeModal');
                }
            });
        });
        onUnmounted(() => {
            emitter.off('onReceiveDomainConnectConfirmation');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(UITextLgMedium), { class: "font-semibold py-3" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('otherProviderHeading')), 1)
                    ]),
                    _: 1
                }),
                _createVNode(DomainConnectRecordTable, { recordTableData: __props.recordTableData }, null, 8, ["recordTableData"]),
                (_unref(isErrorVerifyingDomain).state)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_unref(UIAlert), {
                            id: "verifyDomainError",
                            type: 'error'
                        }, _createSlots({
                            title: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('verifyDomainErrorTitle')), 1)
                            ]),
                            _: 2
                        }, [
                            (_unref(isErrorVerifyingDomain).errorMessage)
                                ? {
                                    name: "content",
                                    fn: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(isErrorVerifyingDomain).errorMessage), 1)
                                    ]),
                                    key: "0"
                                }
                                : undefined
                        ]), 1024)
                    ]))
                    : (!_unref(isErrorVerifyingDomain).state && _unref(isLoading))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_unref(UIAlert), {
                                id: "verifyingDomainWarning",
                                type: 'warning'
                            }, {
                                title: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('verifyDomainWarningTitle')), 1)
                                ]),
                                _: 1
                            })
                        ]))
                        : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("a", {
                            style: { "all": "initial", "cursor": "pointer" },
                            href: _unref(getHelpVideoLink)(__props.configuration.team),
                            target: "_blank"
                        }, [
                            _createVNode(_unref(UITextSmMedium), { class: "flex gap-2" }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(PlaySquareIcon), { class: "w-5" }),
                                    _createTextVNode(_toDisplayString(_ctx.$t('helpVideoLabel')), 1)
                                ]),
                                _: 1
                            })
                        ], 8, _hoisted_5),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(UIButton), {
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('resetState'))),
                                id: "back",
                                disabled: _unref(isLoading)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('back')), 1)
                                ]),
                                _: 1
                            }, 8, ["disabled"]),
                            _createVNode(_unref(UIButton), {
                                disabled: !__props.recordTableData.length,
                                loading: _unref(isLoading),
                                onClick: verifyDomain,
                                id: "addedRecord",
                                type: "primary"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('verifyRecords')), 1)
                                ]),
                                _: 1
                            }, 8, ["disabled", "loading"])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
